export enum TagType {
  AT = '@',
  HASH_TAG = '#',
}

export interface Tag {
  // The identified tag
  content: string;
  // Tag offset in the text
  offset: number;
  // Type of the tag
  type: TagType;
}

export interface TagResult {
  current?: Tag;
  tags: readonly Tag[];
}
